import React from "react";
import { Col, Row } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import { GrTest } from "react-icons/gr";
import styles from './package.module.scss';

const ViewAllTest = ({ viewAllclinicPackage, setViewAllclinicPackage, healthScreeningPackagesById }) => {

    const testProfileList =
        [
            ...(healthScreeningPackagesById?.tests?.map(test => test.testName) || []),
            ...(healthScreeningPackagesById?.profiles?.map(profile => profile.profileName) || []),
           ...(healthScreeningPackagesById?.radiology?.flatMap(radiologydetailsname => radiologydetailsname.rediologyServiceDetails?.map(detail => detail.name) || []
        ) || [])
        ];

    return (
        <>
            <Modal
                centered
                show={viewAllclinicPackage}
                onHide={() => setViewAllclinicPackage(false)}
                size={"xl"}
            >
                <div className="modal-header">
                    <h3 className="modal-title" id="exampleModalLabel">
                        All Test Masters in {healthScreeningPackagesById?.clinicId?.clinicName}
                    </h3>
                    <button
                        type="button"
                        className="btn-close"
                        onClick={() => setViewAllclinicPackage(false)}
                    ></button>
                </div>
                <div className="modal-body">
                    <Row>
                        {testProfileList && testProfileList?.map((item, index) => (
                            <Col xl={4} key={index}>
                                <div className={styles.testCard}>
                                    <div className={styles.testCardInner}>
                                        <GrTest />
                                        <p className={styles.testName}>{item}</p>
                                    </div>
                                </div>
                            </Col>
                        ))}
                    </Row>
                </div>
            </Modal>
        </>
    );
};

export default ViewAllTest;